var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4775 28.9589C10.132 28.528 10.2013 27.8986 10.6322 27.5532C11.0632 27.2077 11.6925 27.277 12.038 27.7079L10.4775 28.9589ZM21.6667 32.3334C28.4782 32.3334 34 26.8116 34 20.0001H36C36 27.9162 29.5827 34.3334 21.6667 34.3334V32.3334ZM34 20.0001C34 13.1886 28.4782 7.66675 21.6667 7.66675V5.66675C29.5827 5.66675 36 12.084 36 20.0001H34ZM21.6667 7.66675C14.8552 7.66675 9.33333 13.1886 9.33333 20.0001H7.33333C7.33333 12.084 13.7506 5.66675 21.6667 5.66675V7.66675ZM12.038 27.7079C14.2999 30.5296 17.7723 32.3334 21.6667 32.3334V34.3334C17.1398 34.3334 13.1026 32.2337 10.4775 28.9589L12.038 27.7079Z",
    fill: "#8E53E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39844 8.03003L7.23773 18.4759L18.005 18.6366",
    stroke: "#8E53E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3764a5811ac066d92979e98f018d822f.svg";
export { ForwardRef as ReactComponent };